import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  userName,
  isCurrentUser,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { bgcolor: '#2C2C2F', color: '#fff' } }}
    >
      <DialogTitle>Confirmar Exclusão</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: '#bdbdbd' }}>
          Você tem certeza que deseja excluir o usuário <strong>{userName}</strong>?
          Esta ação é irreversível.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: '#e0e0e0' }}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          autoFocus
          disabled={isCurrentUser}
        >
          Confirmar Exclusão
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationDialog;
